export default __webpack_public_path__ + "static/media/2.25218925.jpg";